import Loader from '@/components/common/Loader'
import { useHubspotForm } from 'next-hubspot'
import { useEffect, useState } from 'react'
import { contactSeoState } from '@/store/slices/headSlice'

const Contact = () => {
  const [loading, setLoading] = useState(true)
  // Load HubSpot Form
  useHubspotForm({
    portalId: '46037834',
    formId: '10bf4027-a932-410b-817e-651673a3993b',
    target: '#hubspot-form-wrapper',
  })

  useEffect(() => {
    const handleOnLoadingForms = () => {
      setLoading(false)
    }
    window.addEventListener('hs-form-event:on-ready', handleOnLoadingForms)

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleOnLoadingForms)
    }
  }, [])

  return (
    <>
      {loading && <Loader />}
      <div className="w-full md:w-1/2 mx-auto" id="hubspot-form-wrapper"></div>
    </>
  )
}

export async function getServerSideProps() {
  return { props: { seo: contactSeoState } }
}

export default Contact
